import clsx from 'clsx';
import type { FunctionComponent, HTMLAttributes } from 'react';

export const BoardHeaderWrapper: FunctionComponent<HTMLAttributes<HTMLDivElement>> = ({
    children,
    className,
    ...props
}) => (
    <div className={clsx('flex flex-1 flex-col flex-wrap gap-xxl', className)} {...props}>
        {children}
    </div>
);

export const Row: FunctionComponent<HTMLAttributes<HTMLDivElement>> = ({ children, className, ...props }) => (
    <div className={clsx('flex flex-1 flex-row gap-xxl', className)} {...props}>
        {children}
    </div>
);

export const RightSide: FunctionComponent<HTMLAttributes<HTMLDivElement>> = ({ children, className, ...props }) => (
    <div
        className={clsx(
            'flex flex-1 items-start justify-end gap-s',
            'font-sans text-sm font-normal tracking-tight text-gray-800 [&>svg]:text-gray-700',
            className,
        )}
        {...props}
    >
        {children}
    </div>
);
